module.exports = "/cyber/_next/static/images/character-7ebe8f08cca64ad2aac9c6244ba83cbf.png";